// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tooltipZIndex":"3","tooltipSpacing":"10px","stars":"t1RKPGaNHKT-","star":"TFuvh6dlrQoU","isSelected":"d6QdCsUQUpyy","hoverEffectsDefault":"+5agEj9+fgBl"};